import { apiFetch } from "../helper/apiClient";
import { setAccessToken, clearAccessToken } from "../helper/authStore";

export async function login(email, password) {
  const res = await apiFetch("user/login", {
    method: "POST",
    body: JSON.stringify({
      email: email,
      password: password
    }),
  }, { retryOn401: false });

  const body = await res.json();
  if (!res.ok) throw new Error(body.detail || "Login failed");
  setAccessToken(body.access);
  return body.user; // if you return user
}

export async function logout() {
  // tells backend to clear refresh cookie
  await apiFetch("user/logout", { method: "POST" }, { retryOn401: false });
  clearAccessToken();
}

export async function bootstrapSession() {
  console.log("Bootstrapping session...");
  let res;

  try {
    res = await apiFetch(
      "user/login/refresh",
      { method: "POST" },
      { retryOn401: false }
    );
  } catch (err) {
    console.error("Refresh request failed (network/CORS):", err);
    clearAccessToken();
    return false;
  }

  let body;
  try {
    body = await res.clone().json();
  } catch (err) {
    console.warn("Refresh response had no JSON body");
    body = null;
  }

  if (!res.ok) {
    console.error("Refresh failed", {
      status: res.status,
      statusText: res.statusText,
      body,
    });
    clearAccessToken();
    return false;
  }

  console.log("Refresh success");
  setAccessToken(body.access);
  return true;
}


export async function register(email, password, firstName, lastName, birthday =null, tikTokName ='') {
  const res = await apiFetch(
    "user/register",
    {
      method: "POST",
      body: JSON.stringify({
        email: email,
        first_name: firstName, 
        last_name: lastName,
        tiktok_name: tikTokName,
        password: password,
        birthday: birthday }),
    },
    { auth: false, retryOn401: false } // public endpoint
  );

  const body = await res.json().catch(() => ({}));

  if (!res.ok) {
    console.log(body.detail);
    console.log(body.message);
    throw new Error(body.detail || body.message);
  }

  console.log(res);

  return res.status; // 201 expected
}
